import { React, useState, useContext, useEffect, useRef } from "react";
import SubHeader from "./SubHeader";
import { FormGroup, Col, Label, Input, Form, Row, NavLink, ListInlineItem, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, } from "reactstrap";
import projectPlaceholderImg from "../../assets/images/no-projects.png";
import { MDBBtn, MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import Select from "react-select";
import { GlobalContext } from "../../App";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import { FaEdit, FaTimes,FaRedo } from "react-icons/fa";
import HoverTooltip from "../../components/global/Tooltip";
import TopHeader from "./TopHeader";
import { BsChevronRight } from "react-icons/bs";
import { InfinitySpin } from "react-loader-spinner";
import { useNavigate, useLocation } from "react-router-dom";
function Project() {
  const navigate = useNavigate();
  const currentDate = new Date().toISOString().substr(0, 10);
  const inputFile = useRef(null);
  const body = document.body;
  const mainPanel = document.querySelector(".main-panel");
  const maskBgOverlay = document.createElement("div");
  maskBgOverlay.id = "maskBgOverlay";
  maskBgOverlay.className = "maskBgOverlay";
  const location = useLocation();
  const { pathname } = location;
  const params = new URLSearchParams(location?.search);
  var param1 = params.get("param1")
  ? parseInt(atob(params.get("param1")))
  : null;
  const { rolexModuleData, user_id, serialSequence, roles, userProfile } =
    useContext(GlobalContext);
  const isSpecialAccess = rolexModuleData?.find( (data) => pathname === data?.description && data?.special === 1 )|| roles?.find((data1) => data1?.role_id === 1001) ? true : false;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [modal, setModal] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [userStatus, setUserStatus] = useState("All");
  const [companyList, setCompanyList] = useState([]);
  const [buList, setBuList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [projectData, setProjectData] = useState({
    projectTitle: null,
    projectDesc: null,
    projectStartDate: null,
    projectEndDate: null,
    projectOwner: [],
    updateId: null,
    projectStatus: { label: "Pipeline", value: "Pipeline" },
    projectOwnerId: [],
    projectDocument: null,
    company:
    [
      {
        label: userProfile?.company?.company_name,
        value: userProfile?.company?.company_id,
      },
    ] || [],
  bu:
    [{ label: userProfile?.bu?.bu_name, value: userProfile?.bu?.bu_id }] ||
    [],
  department:
    [
      {
        label: userProfile?.department?.department_name,
        value: userProfile?.department?.department_id,
      },
    ] || [],
  });
  const [userDataList, setUserDataList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [tempProjectList, setTempProjectList] = useState([]);
  const [milestoneUserList, setMilestoneUserList] = useState([]);
  const [taskUserList, setTaskUserList] = useState([]);
  const [filterProject, setFilterProject] = useState({
    projectId: "",
    projectTitle: "",
    projectStartDate: "",
    projectEndDate: "",
    createdBy: "",
  });
  const [loading, setLoading] = useState(true); 
   // Handle Error
   const handleError = (error) => {
    setLoading(false); 
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };
  // ----------------------------------------------------------- Handle Close ---------------------------------------
  const handleClose = () => {
    setModal(false);
    setIsFilter(false);
    setProjectData({
      projectTitle: null,
      projectDesc: null,
      projectStartDate: null,
      projectEndDate: null,
      projectOwner: [],
      updateId: null,
      projectStatus: { label: "Pipeline", value: "Pipeline" },
      projectOwnerId: [],
      projectDocument: null,
      company:
      [
        {
          label: userProfile?.company?.company_name,
          value: userProfile?.company?.company_id,
        },
      ] || [],
    bu:
      [{ label: userProfile?.bu?.bu_name, value: userProfile?.bu?.bu_id }] ||
      [],
    department:
      [
        {
          label: userProfile?.department?.department_name,
          value: userProfile?.department?.department_id,
        },
      ] || [],
    });
    body.style.overflow = "";
    document.getElementById("maskBgOverlay").remove();
    setFile("");
  };

  const toggleModal = () => {
    setIsFilter(false);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };

  const toggleFilter = () => {
    setIsFilter(true);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };
  // -------------------------------------------------------- Get User Data --------------------------------------
  const getUserData = () => {
    setLoading(true);
    const UserListCriteria  =  isSpecialAccess ? '' : userProfile || '';
    axios
      .get(`/getUserData?UserListCriteria=${JSON?.stringify(UserListCriteria)}`)
      .then((response, error) => {
        const userDataList = response?.data?.[0]?.user_data ?.filter((item) => item?.isActive === "1") ?.map((item) => ({ label: item?.name, value: item?.user_id, email: item?.email_id, })) || [];
        setUserDataList(userDataList);
        const userList = response?.data?.[0]?.user_data?.filter( (item) => item?.user_id === user_id )?.[0]?.user_x_project;
        const temp = [...new Set(userList?.filter((item) => item?.project_access === 1 || item?.createdBy === user_id)?.map((data) => data?.project_id))];
        // const temp = userList ?.filter((item) => item?.project_access === 1 || item?.createdBy === user_id) ?.map((data) => data?.project_id);
        const milestoneUserList = response?.data?.[0]?.user_data ?.filter((item) => item?.user_id === user_id)?.[0] ?.user_x_milestone?.filter((data) => data?.milestone_access === 1) ?.map((data) => data?.milestone_id);
        const taskUserList = response?.data?.[0]?.user_data ?.filter((item) => item?.user_id === user_id)?.[0] ?.user_x_task?.filter((data) => data?.task_access === 1) ?.map((data) => data?.task_id);
        setMilestoneUserList(milestoneUserList);
        setTaskUserList(taskUserList);
        getProjectList(temp); 
        setLoading(false); 
      })
      .catch(handleError);
  };
  // ------------------------------------------------------- Add Project --------------------------------------------
  const postAddProject = (e) => {
    if (
      projectData?.projectTitle === null ||
      projectData?.projectTitle === ""
    ) {
      e.preventDefault();
      toast.error("Project title is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      projectData?.projectDesc === null ||
      projectData?.projectDesc === ""
    ) {
      e.preventDefault();
      toast.error("Project description is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      (projectData?.projectStartDate === null ||
        projectData?.projectStartDate === "") &&
      projectData?.projectStatus?.value !== "Pipeline"
    ) {
      e.preventDefault();
      toast.error("Start date is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      (projectData?.projectEndDate === null ||
        projectData?.projectEndDate === "") &&
      projectData?.projectStatus?.value !== "Pipeline"
    ) {
      e.preventDefault();
      toast.error("End date is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      projectData?.projectStartDate > projectData?.projectEndDate &&
      projectData?.projectStatus?.value !== "Pipeline"
    ) {
      e.preventDefault();
      toast.error("Project end date cannot be greater than start date!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (projectData?.projectOwner?.length <= 0) {
      e.preventDefault();
      toast.error("Please select team members!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (!projectData?.projectOwnerId?.value) {
      e.preventDefault();
      toast.error("Please select owner first!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      !projectData?.projectOwner?.some(
        (owner) => owner.value === projectData?.projectOwnerId?.value
      )
    ) {
      e.preventDefault();
      toast.error("Please select Owner in team members!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }
    else if (projectData?.company?.length <= 0) {
      e.preventDefault();
      toast.error("Please select company first!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }
    else if (projectData?.bu?.length <= 0) {
      e.preventDefault();
      toast.error("Please select bu first!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }
    else if (projectData?.department?.length <= 0) {
      e.preventDefault();
      toast.error("Please select department first!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }  else {
      // if (
      //   !projectData?.projectOwner?.some(
      //     (member) => member.value === user_id
      //   ) &&
      //   !roles?.find((data) => data?.role_id === 1001)
      // ) {
      //   e.preventDefault();
      //   projectData?.projectOwner?.push({
      //     label: userProfile?.name,
      //     value: user_id,
      //     email: userProfile?.emailId,
      //   });
      // }
      let formData = new FormData();
      formData.append("project_doc", file);
      formData.append("user_id", user_id);
      formData.append("projectId", serialSequence?.[0]?.project_seqence);
      formData.append("userProfile", JSON?.stringify(userProfile));
      formData.append("projectData", JSON?.stringify(projectData));
      // const params = {
      //   projectData: projectData,
      //   user_id: user_id,
      //   projectId: serialSequence[0]?.project_seqence,
      //   userProfile:userProfile
      // }
      axios
        .post("/postAddProject", formData)
        .then((response) => {
          if (response.status === 202) {
            e.preventDefault();
            toast.error("Project already exist!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
          } else {
            toast.success(
              `Project is ${
                projectData?.updateId != null ? "updated" : "created"
              } successfully!`,
              {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored",
                autoClose: 2000,
              }
            );
            handleClose();
            getUserData();
          }
        })
        .catch(handleError);
    }
  };

  // -------------------------------------------------------- Get Project List --------------------------------------
  const getProjectList = (projectList) => {
    setLoading(true);
    const ProjectList  = param1 ? param1 : isSpecialAccess ? [] : projectList?.length > 0 ? projectList : [0];
    axios.get(`/getProjectList?ProjectList=${ProjectList}`)
      .then((response) => {
        setProjectList( response?.data?.[0]?.project_data);
        setTempProjectList( response?.data?.[0]?.project_data);
        setLoading(false); 
      })
      .catch(handleError);
  };

  // --------------------------------------------------- Update Project -------------------------------------------
  const UptProject = (project_id) => {
    setModal(!modal);
    for (let i = 0; i < projectList?.length; i++) {
      if (projectList[i]?.project_id === project_id) {
        const OwnerList =
          projectList[i]?.project_x_owner?.map((item) => ({
            label: item?.user_data?.[0]?.name,
            value: item?.user_id,
          })) ?? [];
          const CompanyList =
          projectList[i]?.company_data?.map((item) => ({
            label: item?.company_name,
            value: item?.company_id,
          })) ?? [];
        const BUList =
          projectList[i]?.bu_data?.map((item) => ({
            label: item?.bu_name,
            value: item?.bu_id,
          })) ?? [];
        const DepartmentList =
          projectList[i]?.department_data?.map((item) => ({
            label: item?.department_name,
            value: item?.department_id,
          })) ?? [];
        setProjectData({
          ...projectData,
          projectTitle: projectList[i]?.project_title,
          projectDesc: projectList[i]?.project_description,
          projectStartDate: projectList[i]?.start_date,
          projectEndDate: projectList[i]?.end_date,
          projectOwner: OwnerList,
          updateId: projectList[i]?.project_id,
          projectStatus: {
            label: projectList[i]?.project_status,
            value: projectList[i]?.project_status,
          },
          projectOwnerId: {
            label: projectList[i]?.project_owner?.[0]?.name,
            value: projectList[i]?.project_owner_id,
          },
          projectDocument: projectList[i]?.project_document,
          company: CompanyList || [],
        bu: BUList || [],
        department: DepartmentList || [],
          // company: { label:projectList[i]?.company_name, value: projectList[i]?.company_id , } || '',
          // bu: { label: projectList[i]?.bu_name, value:  projectList[i]?.bu_id , } || '',
          // department: { label: projectList[i]?.department_name, value: projectList[i]?.department_id, } || '',
        });
      }
    }
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };
  // ---------------------------------------------------------- Project Status list --------------------------------------
  const projectStatusList = [
    { value: "Pipeline", label: "Pipeline" },
    { value: "In Progress", label: "In Progress" },    
    { value: "Completed", label: "Completed" },
    { value: "Cancelled", label: "Cancelled" },
    { value: "On Hold", label: "On Hold" }
  ];
  // -------------------------------------------------------- Filter Project List --------------------------------------
  const filtrerProjectList = (clear) => {
  const filterProjects = tempProjectList?.filter(
      (data) =>
          (!filterProject?.projectId ||
              data?.project_title?.includes(filterProject.projectId) ||
              data?.project_code?.includes(filterProject.projectId)) &&
          (!filterProject?.projectStartDate ||
              data?.start_date?.includes(filterProject.projectStartDate)) &&
          (!filterProject?.projectEndDate ||
              data?.end_date?.includes(filterProject.projectEndDate)) &&
          (!filterProject?.createdBy ||
              data?.created_user?.[0]?.name?.includes(filterProject.createdBy))
  );

  setProjectList(filterProjects);

  if (clear) {
      handleClose();
  }
};
 // ------------------------------------------------------- Clear Filter Field ------------------------------------------
  const ClearFilter = () => {
    setFilterProject({
      projectId: "",
      projectTitle: "",
      projectStartDate: "",
      projectEndDate: "",
      createdBy: "",
    });
    filtrerProjectList(false);
    setProjectList(tempProjectList);
  };

  // ---------------------------------------------------------- Mantain Log History ------------------------------
  const postLogHistory = () => {
    const param = {
      user_id: user_id,
      module_name: "Project",
      operationPerformed: "navigate to project screen",
    };
    axios.post("/postLogHistory", param);
  };

  // ------------------------------------------------------------ Choose Document -----------------------------------
  const [file, setFile] = useState("");
  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files?.[0]);
    }
  };
  // ----------------------------------------------------------------- Document Select ---------------------------------

  const onButtonClick = () => {
    inputFile.current.click();
  };


  const FileManage = () => {
    setFile();
    setProjectData({...projectData,  projectDocument: null})
  };
    // -------------------------------------------------------------- get Company Data ------------------------------------
    const getCompBuDeptData = () => {
      setLoading(true); 
      axios.get('/getCompBuDeptData').then((response) => {
          const companyList = response?.data?.[0]?.company_data?.filter((item)=> item?.bu_data)?.map((item) => ({ label: item?.company_name, value: item?.company_id, buData: item?.bu_data })) ?? [];
          setCompanyList(companyList);
          const BuList =companyList?.[0]?.buData?.map((data)=>({label : data?.bu_name ,value: data?.bu_id, departmentData : data?.department_data}));
          setBuList(BuList);
          const departmentList = BuList?.[0]?.departmentData?.map((data)=>({label : data?.department_name ,value: data?.department_id}));
          setDepartmentList(departmentList)
          setLoading(false); 
      }).catch(handleError);
  }
  // ----------------------------------------------------------------- Manage BU List --------------------------------------
  const manageBuList = (select) =>{
    setProjectData({ ...projectData, company: select, bu: [],department:[]  })
    const BuList = select?.[0]?.buData?.map((data)=>({label : data?.bu_name ,value: data?.bu_id, departmentData : data?.department_data}));
    setBuList(BuList)
}
// ----------------------------------------------------------------- Manage Department List --------------------------------
const manageDepartmentList = (select) =>{
  setProjectData({ ...projectData, bu: select,department:[] })
  const departmentList = select?.[0]?.departmentData?.map((data)=>({label : data?.department_name ,value: data?.department_id}));
  setDepartmentList(departmentList)
}
  // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {
    getUserData();
    // postLogHistory();
    getCompBuDeptData();    
  }, []);
  return (
    loading ? (
      <div className="loader">
      <InfinitySpin width="200" color="#D81159" />
    </div>
    ) : (<>
      <TopHeader
        breadCrumb={
          <>
            <li className="nav-item">
              <a onClick={() => navigate("/home")} className="nav-link">
                Home <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <span>Projects</span>
            </li>
          </>
        }
      />

      <SubHeader
        SubHeaderTitle="Status"
        ShowFilterIcon={true}
        openSidebar={modal}
        isFilter={isFilter}
        handleClose={handleClose}
        toggleModal={toggleModal}
        toggleFilter={toggleFilter}
        handleSubmit={postAddProject}
        filterSubmit={filtrerProjectList}
        titleButton={`${projectData?.updateId ? "Edit" : "Add"} Project`}
        showButton={
          rolexModuleData?.find(
            (data) => pathname === data?.description && data?.create === 1
          )||
          roles?.find((data) => data?.role_id === 1001)
            ? true
            : false
        }
        AddUserContent={
          <Form className="modelform">
            <FormGroup>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="projectTitle">Project Title *</Label>
                    <Input
                      type="text"
                      id="projectTitle"
                      name="projectTitle"
                      value={projectData?.projectTitle || ""}
                      onChange={(e) =>
                        setProjectData({
                          ...projectData,
                          projectTitle: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userRole">Team Members *</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="multi-select"
                      menuPlacement="auto"
                      maxMenuHeight={200}
                      value={projectData?.projectOwner}
                      onChange={(select) =>
                        setProjectData({ ...projectData, projectOwner: select })
                      }
                      options={userDataList}
                      isMulti
                      // {...props}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userRole">Project Owner *</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="multi-select"
                      menuPlacement="auto"
                      maxMenuHeight={200}
                      value={projectData?.projectOwnerId}
                      onChange={(select) =>
                        setProjectData({
                          ...projectData,
                          projectOwnerId: select,
                        })
                      }
                      options={projectData?.projectOwner}
                      // {...props}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="projectDesc">Description*</Label>
                    <Input
                      type="textarea"
                      id="projectDesc"
                      name="projectDesc"
                      value={projectData?.projectDesc || ""}
                      onChange={(e) =>
                        setProjectData({
                          ...projectData,
                          projectDesc: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="status">Status*</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="single-select"
                      menuPlacement="top"
                      maxMenuHeight={200}
                      value={projectData?.projectStatus}
                      onChange={(select) =>
                        setProjectData({
                          ...projectData,
                          projectStatus: select,
                        })
                      }
                      options={projectStatusList}
                      // isMulti
                      // {...props}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />{" "}
                  </FormGroup>
                </Col>
                {projectData?.projectStatus?.value === "Pipeline" ? null : (
                  <>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="startDate">Start Date *</Label>
                        <Input
                          type="date"
                          id="startDate"
                          name="startDate"
                          value={projectData?.projectStartDate || ""}
                          onChange={(e) =>
                            setProjectData({
                              ...projectData,
                              projectStartDate: e.target.value,
                            })
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="endDate">End Date *</Label>
                        <Input
                          type="date"
                          id="endDate"
                          name="endDate"
                          value={projectData?.projectEndDate || ""}
                          onChange={(e) =>
                            setProjectData({
                              ...projectData,
                              projectEndDate: e.target.value,
                            })
                          }
                        />
                      </FormGroup>
                    </Col>
                  </>
                )}
                {isSpecialAccess ?
                <>
                    <Col md={6}>
                  <FormGroup>
                    <Label htmlFor="userRole">Company*</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="multi-select"
                      menuPlacement="top"
                      maxMenuHeight={200}
                      onChange={(select) => manageBuList(select)}
                      options={companyList}
                      value={projectData?.company || ""}
                      isMulti
                      // {...props}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor="userRole">BU*</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="multi-select"
                      menuPlacement="top"
                      maxMenuHeight={200}
                      onChange={(select) => manageDepartmentList(select)}
                      options={buList}
                      value={projectData?.bu || ""}
                      isMulti
                      // {...props}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userRole">Department*</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="multi-select"
                      menuPlacement="top"
                      maxMenuHeight={200}
                      onChange={(select) =>
                        setProjectData({ ...projectData, department: select })
                      }
                      options={departmentList}
                      value={projectData?.department || ""}
                      isMulti
                      // {...props}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />
                  </FormGroup>
                </Col>
                </> : 
                '' }
            
            <Col md={12}> 
                <FormGroup>
                  <Label htmlFor="brdDocument">BRD Document</Label>
                  {projectData?.projectDocument ?
                    <span style={{display:"flex",textDecoration:"underline",color:"#156cdb"}}>{projectData?.projectDocument}   <NavLink onClick={FileManage} style={{ padding: "0", lineHeight: "14px", marginLeft: "6px", }} > <FaTimes  className="svgicon" style={{margin:"4px 0"}} /> </NavLink></span>
           :
                  (file ? 
                   
                   <span style={{display:"flex",textDecoration:"underline",color:"#156cdb"}}>{file?.name}
                    <NavLink onClick={FileManage} style={{ padding: "0", lineHeight: "14px", marginLeft: "6px", }} > 
                    <FaTimes className="svgicon" style={{margin:"4px 0"}} />
                    </NavLink> </span> :
                  <div className="file-input" onClick={() => { onButtonClick() }}>
                  <span className="plus-icon">+</span>
                  <label className="button" for="myFile">Browse File</label>         
                  <input
                      accept=".pdf,.docx,.doc"
                      id="task-document"
                      ref={inputFile}
                      onChange={onSelectFile}
                      name="document"
                      type="file"
                  />
                </div>)}
                 </FormGroup>
                </Col>        
              </Row>
            </FormGroup>
          </Form>
        }
        userStatus={
          <ListInlineItem>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
              <DropdownToggle className="activeuser" caret>
                {userStatus}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => setUserStatus("In Progress")}>
                  In Progress
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("Pipeline")}>
                  Pipeline
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("Completed")}>
                  Completed
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("Cancelled")}>
                  Cancelled
                </DropdownItem>
                <DropdownItem onClick={() => setUserStatus("On Hold")}>
                  On Hold
                </DropdownItem>
                {/* <DropdownItem onClick={() => setUserStatus("Analysis")}>Analysis</DropdownItem> */}
                {/* <DropdownItem onClick={() => setUserStatus("UAT")}>UAT</DropdownItem> */}
                {/* <DropdownItem onClick={() => setUserStatus("Design")}>Design</DropdownItem> */}
                <DropdownItem onClick={() => setUserStatus("All")}>
                  All
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </ListInlineItem>
        }
        SlideBarContent={
          <Form className="modelform">
            <FormGroup>
              <Row>
                <Col md={12}>
                  <div className="resetFilterOption">
                    <a onClick={ClearFilter}>Clear Filter</a>
                  </div>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="projectTitle">Project ID/Title</Label>
                    <Input
                      type="text"
                      id="projectTitle"
                      name="projectTitle"
                      placeholder="Search By Project ID or Title"
                      value={filterProject?.projectId || ""}
                      onChange={(e) =>
                        setFilterProject({
                          ...filterProject,
                          projectId: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="startDate">Start Date</Label>
                    <Input
                      type="date"
                      id="startDate"
                      name="startDate"
                      value={filterProject?.projectStartDate || ""}
                      onChange={(e) =>
                        setFilterProject({
                          ...filterProject,
                          projectStartDate: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="endDate">End Date</Label>
                    <Input
                      type="date"
                      id="endDate"
                      name="endDate"
                      value={filterProject?.projectEndDate || ""}
                      onChange={(e) =>
                        setFilterProject({
                          ...filterProject,
                          projectEndDate: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userRole">Created By</Label>
                    <Input
                      type="text"
                      id="createdBy"
                      name="createdBy"
                      value={filterProject?.createdBy || ""}
                      onChange={(e) =>
                        setFilterProject({
                          ...filterProject,
                          createdBy: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
            </FormGroup>
          </Form>
        }
      />
        {/* <div className="reloadData">
          <FaRedo onClick={getUserData} title="Refresh Data" />
        </div> */}
      <div id="projectManagement">

        <div className="projectheader">
          {projectList?.length > 0 ? (
            projectList?.filter((data) =>
              userStatus === "All" ? data : data?.project_status === userStatus
            )?.length > 0 ? (
              <MDBTable align="middle" className="projectTable">
                <MDBTableHead>
                  <tr>
                    <th scope="col" style={{ minWidth: "320px" }}>
                      Project
                    </th>
                    <th scope="col">Status</th>
                    <th scope="col">Owner</th>
                    <th
                      scope="col"
                      style={{ minWidth: "220px", whiteSpace: "normal" }}
                    >
                      Team Members
                    </th>
                    <th scope="col" className="text-center">
                      Milestone
                    </th>
                    <th scope="col" className="text-center">
                      Tasks
                    </th>
                    <th scope="col">Duration</th>
                    <th scope="col">Start Date</th>
                    <th scope="col">End Date</th>
                    <th scope='col'>BRD Document</th>
                    <th scope="col">Created On</th>
                    <th scope="col">Created By</th>
                    <th scope="col">Modified On</th>
                    <th scope="col">Modified By</th>
                      <th scope="col"> Action</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  {projectList
                    ?.filter((data) =>
                      userStatus === "All"
                        ? data
                        : data?.project_status === userStatus
                    )
                    .map((data) => (
                      <tr className="table-light">
                        <th scope="row">
                          <span className="assignedId">
                            {serialSequence?.[0]?.prefix}-{data?.project_code}
                          </span>{" "}
                          <NavLink
                            a
                            className="d-inline-block ps-2"
                            // onClick={() => navigate( data?.isActive === "1"
                            // ? data?.milestone_master?.length > 0 ? `/milestones?param1=${btoa(
                            //     data?.project_id
                            //   )}&?param2=${btoa(data?.project_title)}` :
                            //   `/task?param1=${btoa(
                            //     data?.project_id
                            //   )}`
                            // : "#")}
                            onClick={() => navigate( data?.isActive === "1"
                            ? `/task?param1=${btoa(
                                data?.project_id
                              )}`
                            : "#")}
                          >
                            {" "}
                            {data?.project_title}{" "}
                          </NavLink>{" "}
                        </th>
                        <td>
                          <div
                            className={
                              "badge " +
                              (data?.project_status).replace(/\s/g, "")
                            }
                          >
                            {data?.project_status}
                          </div>
                        </td>
                        <td>
                          {(data?.project_owner &&
                            data?.project_owner?.[0]?.name) ||
                            " - "}
                        </td>
                        <HoverTooltip
                          arrow
                          title={
                            data?.project_x_owner?.length > 0
                              ? data?.project_x_owner
                                  .map((data) => data?.user_data?.[0]?.name)
                                  .join(", ")
                              : " - "
                          }
                        >
                          <td
                            style={{
                              minWidth: "220px",
                              maxWidth: "250px",
                              webkitLineClamp: "3",
                              webkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {data?.project_x_owner?.length > 0
                              ? data?.project_x_owner
                                  .map((data) => data?.user_data?.[0]?.name)
                                  .join(", ")
                              : " - "}
                          </td>
                        </HoverTooltip>
                        <td>
                          <div className="progressBarWrap">
                            <div className="closedStatus">
                              {data?.milestone_master?.filter(
                                (data) =>
                                  (isSpecialAccess
                                    ? data
                                    : milestoneUserList?.includes(
                                        data?.milestone_id
                                      )) &&
                                  (data?.milestone_status === "Completed" ||
                                    data?.milestone_status === "Cancelled")
                              )?.length || "0"}
                            </div>
                            <HoverTooltip
                              arrow
                              title={
                                <>
                                  {Math.round(
                                    (data?.milestone_master?.filter(
                                      (data) =>
                                        data?.milestone_status ===
                                          "Completed" &&
                                        (isSpecialAccess
                                          ? data
                                          : milestoneUserList?.includes(
                                              data?.milestone_id
                                            ))
                                    )?.length /
                                      data?.milestone_master?.filter((data) =>
                                      isSpecialAccess ? data
                                          : milestoneUserList?.includes(
                                              data?.milestone_id
                                            )
                                      )?.length) *
                                      100
                                  ) || "0"}
                                  % (
                                  {data?.milestone_master?.filter(
                                    (data) =>
                                      (isSpecialAccess
                                        ? data
                                        : milestoneUserList?.includes(
                                            data?.milestone_id
                                          )) &&
                                      data?.milestone_status === "Completed"
                                  )?.length || "0"}{" "}
                                  of{" "}
                                  {data?.milestone_master?.filter((data) =>
                                    isSpecialAccess
                                      ? data
                                      : milestoneUserList?.includes(
                                          data?.milestone_id
                                        )
                                  )?.length || "0"}{" "}
                                  Milestone Completed )
                                </>
                              }
                            >
                              <div
                                className="progress"
                                style={{ height: "15px" }}
                              >
                                <div
                                  className="progress-bar bg-success"
                                  role="progressbar"
                                  style={{
                                    width:
                                      data?.milestone_master?.filter((data) =>
                                      isSpecialAccess
                                          ? data
                                          : milestoneUserList?.includes(
                                              data?.milestone_id
                                            )
                                      )?.length > 0
                                        ? Math.round(
                                            (data?.milestone_master?.filter(
                                              (data) =>
                                                data?.milestone_status ===
                                                  "Completed" &&
                                                (isSpecialAccess
                                                  ? data
                                                  : milestoneUserList?.includes(
                                                      data?.milestone_id
                                                    ))
                                            )?.length /
                                              data?.milestone_master?.filter(
                                                (data) =>
                                                isSpecialAccess
                                                    ? data
                                                    : milestoneUserList?.includes(
                                                        data?.milestone_id
                                                      )
                                              )?.length) *
                                              100
                                          ) + "%"
                                        : "0%",
                                  }}
                                  aria-valuenow="25"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  &nbsp;
                                </div>
                                <div
                                  className={`percentageText ${
                                    Math.round(
                                      (data?.milestone_master?.filter(
                                        (data) =>
                                          data?.milestone_status ===
                                            "Completed" &&
                                          (isSpecialAccess
                                            ? data
                                            : milestoneUserList?.includes(
                                                data?.milestone_id
                                              ))
                                      )?.length /
                                        data?.milestone_master?.filter((data) =>
                                        isSpecialAccess
                                            ? data
                                            : milestoneUserList?.includes(
                                                data?.milestone_id
                                              )
                                        )?.length) *
                                        100
                                    ) > 50
                                      ? "text-white"
                                      : ""
                                  }`}
                                >
                                  {data?.milestone_master?.filter((data) =>
                                    isSpecialAccess
                                      ? data
                                      : milestoneUserList?.includes(
                                          data?.milestone_id
                                        )
                                  )?.length > 0
                                    ? Math.round(
                                        (data?.milestone_master?.filter(
                                          (data) =>
                                            data?.milestone_status ===
                                              "Completed" &&
                                            (isSpecialAccess
                                              ? data
                                              : milestoneUserList?.includes(
                                                  data?.milestone_id
                                                ))
                                        )?.length /
                                          data?.milestone_master?.filter(
                                            (data) =>
                                            isSpecialAccess
                                                ? data
                                                : milestoneUserList?.includes(
                                                    data?.milestone_id
                                                  )
                                          )?.length) *
                                          100
                                      ) + "%"
                                    : "0%"}
                                </div>
                              </div>
                            </HoverTooltip>

                            <div className="openStatus">
                              {data?.milestone_master?.filter(
                                (data) =>
                                  (isSpecialAccess
                                    ? data
                                    : milestoneUserList?.includes(
                                        data?.milestone_id
                                      )) &&
                                  !(data?.milestone_status === "Completed")
                              )?.length || "0"}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="progressBarWrap">
                            <div className="closedStatus">
                              {data?.task_master?.filter(
                                (data) =>
                                  (isSpecialAccess
                                    ? data
                                    : taskUserList?.includes(data?.task_id)) &&
                                  (data?.task_status === "Completed" ||
                                    data?.task_status === "Cancelled")
                              )?.length || "0"}
                            </div>
                            <HoverTooltip
                              arrow
                              title={
                                <>
                                  {Math.round(
                                    (data?.task_master?.filter(
                                      (data) =>
                                        data?.task_status === "Completed" &&
                                        (isSpecialAccess
                                          ? data
                                          : taskUserList?.includes(
                                              data?.task_id
                                            ))
                                    )?.length /
                                      data?.task_master?.filter((data) =>
                                      isSpecialAccess
                                          ? data
                                          : taskUserList?.includes(
                                              data?.task_id
                                            )
                                      )?.length) *
                                      100
                                  ) || "0"}
                                  % (
                                  {data?.task_master?.filter(
                                    (data) =>
                                      (isSpecialAccess
                                        ? data
                                        : taskUserList?.includes(
                                            data?.task_id
                                          )) &&
                                      data?.task_status === "Completed"
                                  )?.length || "0"}{" "}
                                  of{" "}
                                  {data?.task_master?.filter((data) =>
                                    isSpecialAccess
                                      ? data
                                      : taskUserList?.includes(data?.task_id)
                                  )?.length || "0"}{" "}
                                  Task Completed )
                                </>
                              }
                            >
                              <div
                                className="progress"
                                style={{ height: "15px" }}
                              >
                                <div
                                  className="progress-bar bg-success"
                                  role="progressbar"
                                  style={{
                                    width:
                                      data?.task_master?.filter((data) =>
                                      isSpecialAccess
                                          ? data
                                          : taskUserList?.includes(
                                              data?.task_id
                                            )
                                      )?.length > 0
                                        ? Math.round(
                                            (data?.task_master?.filter(
                                              (data) =>
                                                data?.task_status ===
                                                  "Completed" &&
                                                (isSpecialAccess
                                                  ? data
                                                  : taskUserList?.includes(
                                                      data?.task_id
                                                    ))
                                            )?.length /
                                              data?.task_master?.filter(
                                                (data) =>
                                                isSpecialAccess
                                                    ? data
                                                    : taskUserList?.includes(
                                                        data?.task_id
                                                      )
                                              )?.length) *
                                              100
                                          ) + "%"
                                        : "0%",
                                  }}
                                  aria-valuenow="25"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  &nbsp;
                                </div>
                                <div
                                  className={`percentageText ${
                                    Math.round(
                                      (data?.task_master?.filter(
                                        (data) =>
                                          data?.task_status === "Completed" &&
                                          (isSpecialAccess
                                            ? data
                                            : taskUserList?.includes(
                                                data?.task_id
                                              ))
                                      )?.length /
                                        data?.task_master?.filter((data) =>
                                        isSpecialAccess
                                            ? data
                                            : taskUserList?.includes(
                                                data?.task_id
                                              )
                                        )?.length) *
                                        100
                                    ) > 50
                                      ? "text-white"
                                      : ""
                                  }`}
                                >
                                  {data?.task_master?.filter((data) =>
                                    isSpecialAccess
                                      ? data
                                      : taskUserList?.includes(data?.task_id)
                                  )?.length > 0
                                    ? Math.round(
                                        (data?.task_master?.filter(
                                          (data) =>
                                            data?.task_status === "Completed" &&
                                            (isSpecialAccess
                                              ? data
                                              : taskUserList?.includes(
                                                  data?.task_id
                                                ))
                                        )?.length /
                                          data?.task_master?.filter((data) =>
                                          isSpecialAccess
                                              ? data
                                              : taskUserList?.includes(
                                                  data?.task_id
                                                )
                                          )?.length) *
                                          100
                                      ) + "%"
                                    : "0%"}
                                </div>
                              </div>
                            </HoverTooltip>
                            <div className="openStatus">
                              {data?.task_master?.filter(
                                (data) =>
                                  (isSpecialAccess
                                    ? data
                                    : taskUserList?.includes(data?.task_id)) &&
                                  !(data?.task_status === "Completed")
                              )?.length || "0"}
                            </div>
                          </div>
                        </td>
                        <td>
                          {data?.start_date?.length > 0
                            ? Math.floor(
                                (new Date(data?.end_date) -
                                  new Date(data?.start_date)) /
                                  (1000 * 60 * 60 * 24)
                              ) + 1 || " 0 "
                            : " 0 "}{" "}
                          days
                        </td>
                        <td>
                          {data?.start_date?.length > 0
                            ? new Date(data?.start_date).toLocaleDateString(
                                "en-TT"
                              )
                            : " - "}
                        </td>
                        <td
                          className={
                            data?.end_date < currentDate ? "dateExpired" : ""
                          }
                        >
                          {data?.end_date?.length > 0
                            ? new Date(data?.end_date).toLocaleDateString(
                                "en-TT"
                              )
                            : " - "}
                        </td>
                        <td>
                            {data?.project_document ? <NavLink style={{minWidth: "220px", maxWidth: "250px", webkitLineClamp: "3", webkitBoxOrient: "vertical", overflow: "hidden", textOverflow: "ellipsis" }} className='downloadicon' href={data?.project_document} target="_blank">{data?.project_document?.split("/")?.pop()?.split("-")?.slice(1)?.join("-")} </NavLink> : '-'}
                        </td>
                        <td>
                          {new Date(
                            data?.createdDate.split(" ")?.[0]
                          ).toLocaleDateString("en-TT")}
                        </td>
                        <td>
                          {data?.created_user?.length > 0
                            ? data?.created_user?.[0]?.name
                            : "-"}
                        </td>
                        <td>
                          {new Date(
                            data?.updatedDate.split(" ")?.[0]
                          ).toLocaleDateString("en-TT")}
                        </td>
                        <td>
                          {data?.updated_user?.length > 0
                            ? data?.updated_user?.[0]?.name
                            : "-"}
                        </td>
                        {rolexModuleData?.find(
                          (data) =>
                            pathname === data?.description && data?.update === 1
                        ) ||
                        roles?.find((data) => data?.role_id === 1001) ? (
                          <td onClick={() => UptProject(data?.project_id)}>
                            <MDBBtn
                              color="link"
                              rounded
                              size="sm"
                              className="actionBtn"
                            >
                              <FaEdit />
                            </MDBBtn>
                          </td>
                        ) : <td>-</td>}
                      </tr>
                    ))}
                </MDBTableBody>
              </MDBTable>
            ) : (
              <div className="defaultPlaceholder">
                <img src={projectPlaceholderImg} alt="No Project" />
                <h4 className="defaultPlaceholderText">
                  There are no projects under "{userStatus}" status!
                </h4>
              </div>
            )
          ) : (
            <div className="defaultPlaceholder">
              <img src={projectPlaceholderImg} alt="No Project" />
              <h4 className="defaultPlaceholderText">There are no project!</h4>
            </div>
          )}
        </div>
      </div>
    </>)
  );
}

export default Project;
